import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { GreenChevron } from 'src/assets';
import './customSelect.scss';

export const CustomSelect = ({
  value,
  options = [],
  label = '',
  onChange,
  errorMessage = '',
  disabled = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const selectRef = useRef(null);

  useEffect(() => {
    const selectedValue = options?.find((item) => item?.value === value);

    setSelectedOption(selectedValue);
  }, [value, options]);

  const onClickSelect = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const onSelectOption = useCallback(
    (item) => () => {
      onChange(item);
    },
    [onChange],
  );

  const labelStyles = classNames('custom-select__label', {
    'custom-select__label--error': errorMessage,
  });

  const selectStyles = classNames('custom-select', {
    'custom-select--active': isExpanded,
    'custom-select--error': errorMessage,
  });

  const chevronStyles = classNames('custom-select__chevron', {
    'custom-select__chevron--expanded': isExpanded,
  });

  const menuStyles = classNames('custom-select__menu', {
    'custom-select__menu--active': isExpanded,
    'custom-select__menu--inactive': !isExpanded,
  });

  return (
    <div className="custom-select__wrapper">
      {label ? <div className={labelStyles}>{label}</div> : null}
      <div className={selectStyles} onClick={!disabled ? onClickSelect : () => {}} ref={selectRef}>
        {selectedOption?.label}{' '}
        <img className={chevronStyles} src={GreenChevron} alt={GreenChevron} />
      </div>
      {errorMessage ? <div className="custom-input__error">{errorMessage}</div> : null}
      <div className={menuStyles}>
        {options.map((item, index) => {
          const itemStyles = classNames('custom-select__menu__item', {
            'custom-select__menu__item--selected': item?.label === selectedOption?.label,
          });

          return (
            <div key={index} className={itemStyles} onClick={onSelectOption(item)}>
              {item.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
